export default __webpack_public_path__ + "static/logo_white_line-750-c9e6ad80e1112720eb0e7f0cdd1fd539.png";